export interface Testimonial {
  name?: string;
  role?: string;
  message?: string;
  image?: string;
}
  